<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-row>
        <b-col md="5">
          <b-card>
            <div slot="header">
              <strong>My Profile Information</strong>
              <div class="pull-right">
                <button class="btn btn-info" @click="updatePassword"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
              </div>
            </div>

            <b-row style="vertical-align: middle;padding-bottom:5px;">
              <b-col md="10">
                <b-row class="my-1">
                  <b-col md="5">
                    <label>Username:</label>
                  </b-col>
                  <b-col md="7">
                    {{user.login}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col md="5">
                    <label>Name:</label>
                  </b-col>
                  <b-col md="7">
                    {{user.name}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col md="5">
                    <label>E-mail:</label>
                  </b-col>
                  <b-col md="7">
                    {{user.email}}
                  </b-col>
                </b-row>

              </b-col>
            </b-row>

            <b-row>
              <b-col md="10" class="my-0">
                <b-row class="my-1">
                  <b-col md="5"><label for="input-default">New Password:</label></b-col>
                  <b-col md="7">
                    <b-form-input name="newPassword" type="password" placeholder="Type New Password" v-model="newPassword"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col md="5"><label for="input-default">Confirm New Password:</label></b-col>
                  <b-col md="7">
                    <b-form-input name="newPasswordConfirmed" type="password" placeholder="Type New Password" v-model="newPasswordConfirmed"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
        <b-col md="5" v-if="passedValidations.length > 0 || failedValidations.length > 0">
          <b-card>
            <b-row>
              <b-col md="10" class="my-0" v-if="passedValidations.length">
                <div>
                  <b-list-group>
                    <b-list-group-item class="py-2" variant="success" v-for="rule in passedValidations">{{ rule }}</b-list-group-item>
                  </b-list-group>
                </div>
                <div>
                  <b-list-group>
                    <b-list-group-item class="py-2" variant="danger" v-for="rule in failedValidations">{{ rule }}</b-list-group-item>
                  </b-list-group>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import store from '@/store'
import _ from 'lodash'

export default {
  components: {
    loading
  },
  created () {
    var self = this

    if (self.$route.params !== undefined &&
        self.$route.params.notification !== undefined &&
        parseInt(self.$route.params.notification) === 1) {
      self.errMsg = 'Please change default password'
      self.dismissibleType = 'warning'
      self.showDismissibleAlert = true
    }

    self.debouncedCheckPwd = _.debounce(self.checkPwd, 500)

    axios.get('/api/UserManagement/GetCurrent')
      .then(response => {
        self.boolLoading = false
        if (response.data === undefined || response.data === null) {
          self.user = {}
        } else {
          self.user = response.data
        }
      })
      .catch(error => {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      newPassword: '',
      newPasswordConfirmed: '',
      user: {},
      passedValidations: [],
      failedValidations: []
    }
  },

  methods: {
    cleanPasswords (p) {
      var self = this

      self.newPassword = ''
      self.newPasswordConfirmed = ''

      self.passedValidations.splice(0)
      self.failedValidations.splice(0)
    },
    updatePassword (p) {
      var self = this

      self.checkPwd()

      if (self.failedValidations.length === 0) {
        self.$dialog.confirm('Are you sure you would like to update password?')
          .then(function () {
            var obj = {
              newPassword: self.newPassword,
              newPasswordConfirmed: self.newPasswordConfirmed
            }

            axios.post('/api/profile/passwordupdate', obj)
              .then(response => {
                store.commit('PASSWORD_CHANGE_REQUIRED', false)

                self.errMsg = 'Your password has been updated'
                self.dismissibleType = 'success'
                self.showDismissibleAlert = true
                self.boolLoading = false

                self.cleanPasswords()
              })
              .catch(error => {
                if (error.response.status === 403) {
                  self.$router.push('/login')
                }

                console.log(error)
                self.boolLoading = false
                self.errMsg = 'There was an error updating your password: ' + error
                self.showDismissibleAlert = true
              })
          })
          .catch(function () {
            // do nothing
          })
      }
    },
    checkPwd: function () {
      var self = this

      self.passedValidations.splice(0)
      self.failedValidations.splice(0)

      if (!self.newPassword) {
        self.failedValidations.push('New Password is a required field.')
      } else {
        self.passedValidations.push('New Password was provided.')
      }

      if (!self.newPasswordConfirmed) {
        self.failedValidations.push('New Password confirmation is a required field.')
      } else {
        self.passedValidations.push('New Password confirmation was provided.')
      }

      if (self.newPassword !== self.newPasswordConfirmed) {
        self.failedValidations.push('Password doesn\'t match with confirmed password')
      } else {
        self.passedValidations.push('Password does match with confirmed password')
      }

      var pattern = ''
      if (self.newPassword.length < 8 || self.newPassword.length > 25) {
        self.failedValidations.push('Password\'s length must be between 8 and 25 characters')
      } else {
        self.passedValidations.push('Password\'s length is be between 8 and 25 characters')
      }

      // var pattern = /(?=^.{8,25}$)((?=.*\d)(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;
      // pattern = /^(?=.*\d)(?=.*[\[\]!@#$%^&*()\-\+_=~`<>{}|,.<>:;'"\\/?])(?=.*[A-Z]).{8,25}$/;
      // pattern = /(?=^.{8,25}$)(?=.*\d)(?=.*[\[\]!@#$%^&*()\-\+_=~`<>{}|,.<>:;'"\\/?])(?=.*[a-zA-Z])^.+/;
      // self.errors.push('Password is not strong enough. It must be at least 8 characters long and include at least one digit, one capital character and one special symbol.');

      pattern = /^(?=.*[a-z]).{8,25}$/
      if (pattern.test(self.newPassword) === false) {
        self.failedValidations.push('Password\'s must include at least one character')
      } else {
        self.passedValidations.push('Password\'s contains at least one character')
      }

      pattern = /^(?=.*[A-Z]).{8,25}$/
      if (pattern.test(self.newPassword) === false) {
        self.failedValidations.push('Password\'s must include at least one capital character')
      } else {
        self.passedValidations.push('Password\'s contains at least one capital character')
      }

      pattern = /^(?=.*[\[\]!@#$%^&*()\-\+_=~`<>{}|,.<>:;'"\\/?]).{8,25}$/
      if (pattern.test(self.newPassword) === false) {
        self.failedValidations.push('Password\'s must include at least one special symbol')
      } else {
        self.passedValidations.push('Password\'s contains at least one special symbol')
      }

      pattern = /^(?=.*[0-9]).{8,25}$/
      if (pattern.test(self.newPassword) === false) {
        self.failedValidations.push('Password\'s must include at least one digit')
      } else {
        self.passedValidations.push('Password\'s contains at least one digit')
      }
    }
  },
  watch: {
    newPassword: function (newPwd, oldPwd) {
      var self = this

      if (newPwd !== undefined && newPwd !== null && newPwd.length > 0) {
        self.debouncedCheckPwd()
      } else {
        self.cleanPasswords()
      }
    },
    newPasswordConfirmed: function (newPwd, oldPwd) {
      var self = this

      if (newPwd !== undefined && newPwd !== null && newPwd.length > 0) {
        self.debouncedCheckPwd()
      } else {
        self.cleanPasswords()
      }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}

</script>



// WEBPACK FOOTER //
// src/views/MyProfile.vue